import { mapGetters, mapActions } from "vuex";
import { POPUP_STYLE } from "../components/TipPopUpIframe";

export default {
  computed: {
    downloadLink() {
      return `//m.gm99.com/h5/page/download${window.location.search}`;
    },
    isDownloadAward() {
      return this.pageInfo.gift.download;
    },
    isNormalGift() {
      return this.pageInfo.gift.type === "game";
    },
    isNumberGift() {
      return this.pageInfo.gift.type === "number";
    },
    ...mapGetters(["user", "roleInfo", "giftState", "gameId", "pageInfo"])
  },
  methods: {
    downloadFn() {
      // 如果沒有發獎，就直接下载
      if (!this.isDownloadAward) {
        this.doDownload();
        return;
      }

      // 如果還沒進入遊戲，就提示要先進遊戲
      if (!(this.user.id && this.roleInfo.roleId)) {
        this.doDownload("請先進入遊戲再下載，確保獎勵發送至您的郵箱哦～");
        return;
      }

      // 如果已經領過了，就提示已領
      if (this.giftState.download_award) {
        this.doDownload("您已獲得過獎勵哦～");
        return;
      }

      this.doDownload();
      this.$store.dispatch("get_save_gift", "download").then(
        data => {
          this.$store.commit("updateGiftState", {
            action: "download",
            value: true
          });
          if (this.isNormalGift) {
            this.doFavour("獎勵已發送至您的郵箱~");
          }
          if (this.isNumberGift) {
            this.$store.commit("updateState", {
              action: "giftNumberGetPopupState",
              value: data.card
            });
            this.$store.commit("updateGiftCard", {
              action: "download",
              value: data.card
            });
          }
          this.gaStatistics({ eventName: "download_gift" });
        },
        res => {
          this.doDownload("獎勵領取失敗，請稍候再試", POPUP_STYLE.bad, true);
        }
      );
    },
    doDownload(text, style = POPUP_STYLE.good, onlyAlert) {
      if (!onlyAlert) {
        window.open(this.downloadLink, "_blank");
      }

      if (text) {
        this.$store.commit("updateCommonTips", {
          msg: text,
          style: style
        });
      }
    },
    ...mapActions(["gaStatistics"])
  }
};



// WEBPACK FOOTER //
// ./src/mixins/Download.js